import { render } from "./ErrorWrapper.vue?vue&type=template&id=405d84b2&ts=true"
import script from "./ErrorWrapper.vue?vue&type=script&lang=ts"
export * from "./ErrorWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__